"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var executeTime_1 = require("./helpers/executeTime");
var CmeterComponent = /** @class */ (function () {
    function CmeterComponent() {
        var _this = this;
        this.beginTest = function (resources) {
            if (resources === void 0) { resources = []; }
            return __awaiter(_this, void 0, void 0, function () {
                var testResults, _resources, _i, _resources_1, resource, thresholds, testResult;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            testResults = [];
                            _resources = resources;
                            // If no resource provided, add empty resource to call test at least once
                            if (!_resources.length) {
                                _resources.push({ data: "" });
                            }
                            _i = 0, _resources_1 = _resources;
                            _a.label = 1;
                        case 1:
                            if (!(_i < _resources_1.length)) return [3 /*break*/, 4];
                            resource = _resources_1[_i];
                            thresholds = resource.thresholds;
                            return [4 /*yield*/, this.runTest(resource)];
                        case 2:
                            testResult = _a.sent();
                            testResult.threshold = this.calcThreshold(testResult, thresholds);
                            testResults.push(testResult);
                            _a.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, testResults];
                    }
                });
            });
        };
        this.runTest = function (resource) { return __awaiter(_this, void 0, void 0, function () {
            var dateOfTheTest, testPassed, testTime;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dateOfTheTest = new Date();
                        testPassed = false;
                        testTime = 0;
                        return [4 /*yield*/, (0, executeTime_1.measureExecuteTime)(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.performTest(resource.data)];
                                        case 1:
                                            testPassed = _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        testTime = _a.sent();
                        return [2 /*return*/, {
                                passed: testPassed,
                                testTime: testTime,
                                testDate: dateOfTheTest.toISOString(),
                                resource: resource.data,
                            }];
                }
            });
        }); };
        this.calcThreshold = function (testResult, thresholds) {
            if (!(thresholds === null || thresholds === void 0 ? void 0 : thresholds.length)) {
                return "";
            }
            var valueToReturn = "";
            var testTime = testResult.testTime;
            thresholds.forEach(function (threshold) {
                if (threshold.value < testTime)
                    valueToReturn = threshold.name;
            });
            return valueToReturn;
        };
    }
    return CmeterComponent;
}());
exports.default = CmeterComponent;
